import { render, staticRenderFns } from "./mainSafetyHealthyMstCopy.vue?vue&type=template&id=58a7e8c2"
import script from "./mainSafetyHealthyMstCopy.vue?vue&type=script&lang=js"
export * from "./mainSafetyHealthyMstCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a7e8c2')) {
      api.createRecord('58a7e8c2', component.options)
    } else {
      api.reload('58a7e8c2', component.options)
    }
    module.hot.accept("./mainSafetyHealthyMstCopy.vue?vue&type=template&id=58a7e8c2", function () {
      api.rerender('58a7e8c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/main/mainSafetyHealthyMstCopy.vue"
export default component.exports